import common from '@page/common/js/common';
import RenderProductListContent from '@page/productListStatic/js/ProductListContent';
import './HorizontalScrolling';

require('sticky-kit/dist/sticky-kit');

RenderProductListContent();
